export default {
    app: {
        // fontFamily: 'Roboto',
        fontFamily: 'Verlag A, Verlag B, aktiv-grotesk, sans-serif',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        width: '100vw',
        backgroundColor: '#ffffff',
    },
    loadingContainer: {
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100vw'
    },
};